import { render, staticRenderFns } from "./CardColorGradient.vue?vue&type=template&id=06ab1a0c&scoped=true"
import script from "./CardColorGradient.vue?vue&type=script&lang=js"
export * from "./CardColorGradient.vue?vue&type=script&lang=js"
import style0 from "./CardColorGradient.vue?vue&type=style&index=0&id=06ab1a0c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ab1a0c",
  null
  
)

export default component.exports